import { fetcher_default } from "./chunk-GONJSORR.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/services/essays.ts

var essays_exports = {};

__export(essays_exports, {
  createEssayComment: function createEssayComment() {
    return _createEssayComment;
  },
  getEssays: function getEssays() {
    return _getEssays;
  },
  getEssaysTag: function getEssaysTag() {
    return _getEssaysTag;
  },
  setArticleView: function setArticleView() {
    return _setArticleView;
  },
  toggleEssayLike: function toggleEssayLike() {
    return _toggleEssayLike;
  }
});

var _getEssays = function _getEssays(_ref) {
  var categoryId = _ref.categoryId,
      orderKey = _ref.orderKey,
      pinName = _ref.pinName;
  return fetcher_default.get("/v4.1/essays", {
    category_id: categoryId,
    order_key: orderKey,
    pin_name: pinName
  });
};

var _getEssaysTag = function _getEssaysTag(_ref2) {
  var id = _ref2.id,
      orderKey = _ref2.orderKey;
  return fetcher_default.get("/v4.1/essays/tagging_essays", {
    tag_id: id,
    order_key: orderKey
  });
};

var _createEssayComment = function _createEssayComment(_ref3) {
  var id = _ref3.id,
      content = _ref3.content,
      _tag_members = _ref3._tag_members,
      displayText = _ref3.displayText;
  return fetcher_default.post("/v4.1/essays/".concat(id, "/create_comment"), {
    content: content,
    _tag_members: _tag_members,
    displayText: displayText
  });
};

var _toggleEssayLike = function _toggleEssayLike(_ref4) {
  var id = _ref4.id,
      liked = _ref4.liked;
  var action = liked ? "like" : "unlike";
  return fetcher_default.post("/v4.1/essays/".concat(id, "/").concat(action));
};

var _setArticleView = function _setArticleView(id) {
  return fetcher_default.get("/v4.1/essays/".concat(id));
};

export { _getEssays as getEssays, _getEssaysTag as getEssaysTag, _createEssayComment as createEssayComment, _toggleEssayLike as toggleEssayLike, _setArticleView as setArticleView, essays_exports };